package com.schoolconnect.app.repository.homework

import com.schoolconnect.app.datasource.network.KtorApiClient
import com.schoolconnect.app.datasource.network.request.HomeworkCreateRequest
import com.schoolconnect.app.datasource.network.request.HomeworkUpdateRequest
import com.schoolconnect.app.datasource.network.response.HomeworkResponse

sealed interface HomeworkScope {
    data object All : HomeworkScope
    data class School(val schoolId: String) : HomeworkScope
    data class AcademicYear(val academicYearId: String) : HomeworkScope
    data class ClassSection(val classSectionId: String) : HomeworkScope
    data class Teacher(val teacherId: String) : HomeworkScope
    data class User(val userId: String) : HomeworkScope
}

object HomeworkRepository {
    suspend fun get(homeworkId: String): Result<HomeworkResponse> =
        KtorApiClient.getHomeworkById(homeworkId)

    suspend fun create(
        request: HomeworkCreateRequest,
        currentUserId: String? = null
    ): Result<HomeworkResponse> = KtorApiClient.createHomework(request, currentUserId)
        .onSuccess { HomeworkListRepository.invalidateCache() }

    suspend fun update(
        homeworkId: String,
        request: HomeworkUpdateRequest
    ): Result<HomeworkResponse> = KtorApiClient.updateHomework(homeworkId, request)
        .onSuccess { HomeworkListRepository.invalidateCache() }

    suspend fun delete(homeworkId: String): Result<Unit> =
        KtorApiClient.deleteHomework(homeworkId).onSuccess { HomeworkListRepository.invalidateCache() }

    suspend fun close(homeworkId: String): Result<HomeworkResponse> =
        KtorApiClient.closeHomework(homeworkId).onSuccess { HomeworkListRepository.invalidateCache() }

    suspend fun sendReminder(homeworkId: String): Result<Unit> =
        KtorApiClient.sendHomeworkReminder(homeworkId)
}
